import { createSelector } from '@ngrx/store';
import { ingredientsState } from '@shared/state/ingredients/selectors/root';
import { getIngredientByPLU } from '@shared/state';
import { getWizzardSimpleItem } from '../getWizzardSimpleItem';

export const getWizzardIngredientsQuantityForGroup = (ingredientDisplayGroupId: number) =>
    createSelector(getWizzardSimpleItem, ingredientsState, (wizzardSimpleItem: OLO.State.Wizzard.WizzardSimpleItem, ingredients) => {
        if (!wizzardSimpleItem) return 0;

        let totalQty = 0;

        const ingredientsAdded = wizzardSimpleItem.IngredientsChanges?.IngredientsAdded || [];
        const filteredIngredientsAdded = ingredientsAdded.filter((ingredient) => ingredient._IngredientDisplayGroupId === ingredientDisplayGroupId);
        const ingredientsAddedQty = filteredIngredientsAdded.reduce((acc, ingredient) => acc + ingredient.Qty, 0);
        totalQty += ingredientsAddedQty;

        const ingredientsSwapped = wizzardSimpleItem.IngredientsChanges?.IngredientsSwapped || [];
        const filteredIngredientsSwapped = ingredientsSwapped.filter((swap) => swap._IngredientDisplayGroupId === ingredientDisplayGroupId);
        totalQty += filteredIngredientsSwapped.length;

        const addedOrSwappedPLUs = new Set([...ingredientsAdded.map((ing) => ing.IngredientPLU), ...ingredientsSwapped.map((swap) => swap.NewIngredientPLU)]);

        const selectedIngredientPLUs = wizzardSimpleItem.IngredientsChanges?._SelectedIngredientPLUs || [];
        const untrackedPLUs = selectedIngredientPLUs.filter((plu) => !addedOrSwappedPLUs.has(plu));

        untrackedPLUs.forEach((plu) => {
            const ingredient = getIngredientByPLU(plu).projector(ingredients);

            if ('IngredientDisplayGroupId' in ingredient && ingredient.IngredientDisplayGroupId === ingredientDisplayGroupId) {
                totalQty += 1;
            }
        });

        return totalQty;
    });
